const openPopupBtn = document.querySelector('#giftProductPopup');
const popupWrapper = document.querySelector('.cart-popup-wrapper');
const closePopupBtn = document.querySelector('.cart-popup-close');
const popupContainer = document.querySelector('.cart-popup-container');

const openPopup = () => {
  popupWrapper.classList.remove('cart-popup-disabled');
  document.body.style.overflowY = 'hidden';
  document.querySelector(".cart-drawer .drawer__close-icon").click()
};

const closePopup = () => {
  popupWrapper.classList.add('cart-popup-disabled');
  document.body.style.overflowY = '';
};

document.addEventListener('click', (e) => {
  if(e.target.closest('#giftProductPopup')) {
    openPopup()
  }
})

closePopupBtn.addEventListener('click', closePopup);

popupWrapper.addEventListener('click', (event) => {
  if (!popupContainer.contains(event.target)) {
    closePopup();
  }
});

